module.exports = __webpack_public_path__ + "img/catch-feature-img-3.c6b485d0.png";